/* Model */
class TaskStatusModel extends App.Models.BaseModel {
    modelUrl = 'TaskStatus';
}

App.Models.TaskStatus = TaskStatusModel;

/* Collection */
class TaskStatusCollection extends App.Collections.BaseCollection {
    url = 'TaskStatus';
    model = App.Models.TaskStatus;
}

App.Collections.TaskStatuss = TaskStatusCollection;

/* Router */
class TaskStatusRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'TaskStatus';
        const model = App.Models.TaskStatus;
        const collectionClass = App.Collections.TaskStatus;

        super(entityName, model, collectionClass);
    }
}

App.Routers.TaskStatus = TaskStatusRouter;
